import { useState, useEffect } from 'react'

export const useDisappearingContainer = (timeInMS: number) => {
    const [isContainerVisible, setIsContainerVisible] = useState<boolean>(true)

    useEffect(() => {
        if (timeInMS) {
            setTimeout(() => {
                setIsContainerVisible(false)
            }, timeInMS)
        }
    }, [isContainerVisible])

    return { 
        isContainerVisible,
        setIsContainerVisible
    } as const
}